import { render, staticRenderFns } from "./parkingViolationsPay.vue?vue&type=template&id=1290f46d&scoped=true"
import script from "./parkingViolationsPay.vue?vue&type=script&lang=js"
export * from "./parkingViolationsPay.vue?vue&type=script&lang=js"
import style0 from "./parkingViolationsPay.vue?vue&type=style&index=0&id=1290f46d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1290f46d",
  null
  
)

export default component.exports